module.exports = __webpack_public_path__ + "static/media/sample-bulk-orders.a016fed4.csv";